import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { usePrescriptionFormLayout } from '../../context/PrescriptionFormLayoutContext.js';
import { usePrescriptionFormColumn } from '../../hooks/use-prescription-form-column.js';
import PrescriptionFormColumn from './PrescriptionFormColumn.js';

const PrescriptionFormColumnContainer = ({ showHeading , side , parametersType ,  })=>{
    const { getLabel  } = useIntl();
    const prescriptionFormColumnData = usePrescriptionFormColumn({
        side,
        parametersType
    });
    const { layout  } = usePrescriptionFormLayout();
    const hideLeftEyeLabels = side === 'left' && layout !== 'singleColumn';
    if (!prescriptionFormColumnData) return null;
    const { idExtension , prescriptionData , prescriptionValidationState , isSubmitted , opticalParameters ,  } = prescriptionFormColumnData;
    return /*#__PURE__*/ React.createElement(PrescriptionFormColumn, {
        className: `prescription-form__column-${side}`,
        side: side,
        id: `${side}-configurator-${idExtension}`,
        columnTitle: getLabel(`products.glasses.${side}Eye`),
        parameters: opticalParameters,
        selectedValues: prescriptionData,
        validations: prescriptionValidationState,
        showValidation: isSubmitted,
        onAttributeChange: prescriptionFormColumnData.handleChange,
        showHeading: showHeading,
        hideSelectLabels: hideLeftEyeLabels
    });
};

export { PrescriptionFormColumnContainer };
//# sourceMappingURL=PrescriptionFormColumnContainer.js.map
